/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Sec_ResultsInputs */

const en_funnel_demo_sec_results = /** @type {(inputs: Funnel_Demo_Sec_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results`)
};

const es_funnel_demo_sec_results = /** @type {(inputs: Funnel_Demo_Sec_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

/**
* | output |
* | --- |
* | "Results" |
*
* @param {Funnel_Demo_Sec_ResultsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_sec_results = /** @type {((inputs?: Funnel_Demo_Sec_ResultsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Sec_ResultsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_sec_results(inputs)
	return en_funnel_demo_sec_results(inputs)
});